import { 
  Headphones, Wrench, Book, Database, Smartphone, 
  ShoppingCart, Briefcase, BarChart, Info, Network,
  Layers, Lightbulb, Package 
} from 'lucide-react';

export interface NavigationItem {
  title: string;
  description?: string;
  path: string;
  icon: any;
  hidden?: boolean;
}

export interface NavigationGroup {
  title: string;
  icon: any;
  items: NavigationItem[];
  hidden?: boolean;
  columnCount?: 1 | 2 | 3 | 4;      // Anzahl der Spalten im Submenü
  menuWidth?: string;               // CSS-Breite des Submenüs (z.B. "400px", "500px")
}

export const NAVIGATION_CONFIG: {
  consulting: NavigationGroup;
  development: NavigationGroup;
  products: NavigationGroup;
  standalone: NavigationItem[];
} = {
  consulting: {
    title: 'navigation.consulting',
    icon: Headphones,
    columnCount: 1,                 // Nur eine Spalte
    menuWidth: "400px",             // Schmaler als die anderen Menüs
    items: [
      {
        title: 'navigation.digitalizationConsulting',
        description: 'navigation.digitalizationConsultingDesc',
        path: '/consulting',
        icon: Lightbulb,
        hidden: false
      },
      {
        title: 'navigation.ctoService',
        description: 'navigation.ctoServiceDesc',
        path: '/cto-service',
        icon: Lightbulb,
        hidden: true
      }
    ],
    hidden: false
  },
  development: {
    title: 'navigation.development',
    icon: Wrench,
    columnCount: 2,                 // Zwei Spalten
    menuWidth: "600px",             // Breiter
    items: [
      {
        title: 'navigation.businessApps',
        description: 'navigation.businessAppsDesc',
        path: '/business-apps',
        icon: Briefcase,
        hidden: false
      },
      {
        title: 'navigation.shopware',
        description: 'navigation.shopwareDesc',
        path: '/shopware',
        icon: ShoppingCart,
        hidden: false
      },
      {
        title: 'navigation.erp',
        description: 'navigation.erpDesc',
        path: '/erp',
        icon: Database,
        hidden: false
      },
      {
        title: 'navigation.interfaces',
        description: 'navigation.interfacesDesc',
        path: '/interfaces',
        icon: Network,
        hidden: true
      },
      {
        title: 'navigation.portals',
        description: 'navigation.portalsDesc',
        path: '/portals',
        icon: Layers,
        hidden: true
      },
      {
        title: 'navigation.mobileApps',
        description: 'navigation.mobileAppsDesc',
        path: '/mobile-apps',
        icon: Smartphone,
        hidden: false
      }
    ],
    hidden: false
  },
  products: {
    title: 'navigation.products',
    icon: Package,
    columnCount: 1,                 // Nur eine Spalte
    menuWidth: "400px",             // Schmaler
    items: [
      {
        title: 'navigation.salesCockpit',
        description: 'navigation.salesCockpitDesc',
        path: '/salescockpit',
        icon: BarChart,
        hidden: false
      }
    ],
    hidden: false
  },
  standalone: [
    {
      title: 'navigation.references',
      path: '/references',
      icon: Book,
      hidden: true
    },
    {
      title: 'navigation.about',
      path: '/about',
      icon: Info,
      hidden: false
    }
  ]
}; 